// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nU-8","clinicsSelect":"styles_clinicsSelect__3lsk9"};